var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderSettingSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.087,
    height: 17.087,
    viewBox: "0 0 17.087 17.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "setting",
    d: "M63.03,57.4a5.342,5.342,0,0,0,.044-.854c0-.3-.044-.555-.044-.854l1.835-1.41a.392.392,0,0,0,.087-.555L63.2,50.778a.425.425,0,0,0-.524-.171l-2.185.854a6.359,6.359,0,0,0-1.485-.854L58.7,48.343A.468.468,0,0,0,58.267,48h-3.5a.468.468,0,0,0-.437.342l-.349,2.264a7.4,7.4,0,0,0-1.486.854l-2.185-.854a.409.409,0,0,0-.524.171l-1.748,2.948a.516.516,0,0,0,.087.555l1.879,1.41c0,.3-.044.555-.044.854s.044.555.044.854l-1.835,1.41a.392.392,0,0,0-.087.555l1.748,2.948a.426.426,0,0,0,.524.171l2.185-.854a6.359,6.359,0,0,0,1.485.854l.349,2.264a.424.424,0,0,0,.437.342h3.5a.468.468,0,0,0,.437-.342l.35-2.264a7.4,7.4,0,0,0,1.485-.854l2.185.854a.409.409,0,0,0,.524-.171l1.748-2.948a.515.515,0,0,0-.087-.555L63.03,57.4Zm-6.51,2.136a2.991,2.991,0,1,1,3.058-2.99A3.006,3.006,0,0,1,56.519,59.535Z",
    transform: "translate(-47.998 -48.001)",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSettingSmall);
export default __webpack_public_path__ + "static/media/headerSettingSmall.2add31de88866927aa15582fe6b88f90.svg";
export { ForwardRef as ReactComponent };